// extracted by mini-css-extract-plugin
module.exports = {"revision-modal":"revision-modal_revision-modal__qJ1c5","scroll-col":"revision-modal_scroll-col__Pz8_O"};